import React from "react";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";

export const CommonModal = ({ show, setShow, body, title ,size='xl',height="50vh"}) => {
  function handleClose() {
    setShow(false);
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      centered // This centers the modal vertically in the viewport
    >
      <Modal.Header closeButton>{title}</Modal.Header>
      <Modal.Body className="overflow-auto" style={{ height: height }}>
        {body}
      </Modal.Body>
    </Modal>
  );
};
